export const mobileApp = () => `marketing/mobile-app`;

export const timetableWebEmbed = () => `marketing/timetable-web-embed`;

export const playlistGenerator = () => `marketing/playlist-generator`;
